import isNullsy from './isNullsy';

export default function (value) {
    if (isNullsy(value)) {
        return '';
    }

    return value;
};